import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import Purchase from "./views/Purchase.vue";
import Return from "./views/Return.vue";

const routes: RouteRecordRaw[] = [
  // Canonical shareable URL: /event/<slug> (optional ?mode=test).
  { path: "/event/:eventId", name: "purchase", component: Purchase },
  // Legacy form (/?eventId=<slug>) — keep working for links already shared.
  { path: "/", name: "purchase-legacy", component: Purchase },
  { path: "/return", name: "return", component: Return },
];

export const router = createRouter({
  history: createWebHistory("/"),
  routes,
});
